import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PersonCalendar } from '../models/personcalendar.model';
import { Observable } from 'rxjs';

@Injectable()

export class PersonCalendarService {
  private personcalendarUrl: string = 'api/personcalendars';

  constructor(
    private http: HttpClient) { }

  getCalendars(employeeId:number): Observable<PersonCalendar[]> {
    let endpointUrl = `${this.personcalendarUrl}/${employeeId}`;
    return this.http.get<PersonCalendar[]>(endpointUrl);
  }

  addPersonCalendar(personCalendar: PersonCalendar): Observable<PersonCalendar> {
    const normalized = {
      ...personCalendar,
      startDate: this.toIsoDateString(personCalendar.startDate),
      endDate: personCalendar.endDate ? this.toIsoDateString(personCalendar.endDate) : null
    };

    return this.http.post<PersonCalendar>(this.personcalendarUrl, normalized);
  }

  updatePersonCalendar(personCalendar: PersonCalendar): Observable<PersonCalendar> {
    const normalized = {
      ...personCalendar,
      startDate: this.toIsoDateString(personCalendar.startDate),
      endDate: personCalendar.endDate ? this.toIsoDateString(personCalendar.endDate) : null
    };

    return this.http.put<PersonCalendar>(this.personcalendarUrl, normalized);
  }

  toIsoDateString(date: any): string {
    const d = (date instanceof Date) ? date : new Date(date);
    return [
      d.getFullYear(),
      (d.getMonth() + 1).toString().padStart(2, '0'),
      d.getDate().toString().padStart(2, '0')
    ].join('-');  // returns "YYYY-MM-DD" as a local date string
  }

  deletePersonCalendar(empid: number, startdate: Date, basecalendar: number) {
    let sd = new Date(startdate);
    let fullyear = sd.getFullYear();
    let month = ('00' + (sd.getMonth() + 1)).slice(-2);
    let day = ('00' + sd.getDate()).slice(-2);
    let stDate = fullyear + "-" + month + "-" + day ;
    const params = {
      EmployeeId: empid,
      StartDate: stDate,
      Basecalendar: basecalendar
    };
    return this.http.delete(this.personcalendarUrl, { params, responseType: 'text' });



    //return this.http.delete<PersonCalendar>(this.personcalendarUrl, { params, responseType: 'text' });
  }
  
}
